
export default function About() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: '正確性と信頼性',
      description: '最新の測量機器と豊富な経験により、正確で信頼性の高い測量・登記業務を提供します。'
    },
    {
      icon: 'ri-map-pin-line',
      title: '広域対応サービス',
      description: '大分県全域を中心とした広域サービスで、地域の特性を熟知した専門的な対応を行います。'
    },
    {
      icon: 'ri-time-line',
      title: '迅速な対応',
      description: 'お客様のご要望に迅速に対応し、スケジュールに合わせた柔軟なサービスを提供します。'
    },
    {
      icon: 'ri-customer-service-line',
      title: '丁寧なサポート',
      description: '専門的な内容もわかりやすく説明し、お客様が安心して手続きを進められるようサポートします。'
    }
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              芦江土地家屋調査士事務所について
            </h2>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              代表の芦江諒介が運営する土地家屋調査士事務所です。大分県全域を中心に、お客様の大切な不動産に関する測量・登記業務を、正確性と信頼性を第一に、丁寧に対応いたします。
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              土地境界の確定から建物の登記まで、不動産に関するあらゆる手続きをサポート。長年の経験と専門知識を活かし、お客様一人ひとりのニーズに合わせた最適なソリューションを提供します。
            </p>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className={`${feature.icon} text-xl text-blue-600`}></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-2">{feature.title}</h3>
                    <p className="text-sm text-gray-600">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/e43eaececf30c18a405f267202e49ef0.jpg"
              alt="芦江土地家屋調査士事務所の測量機器と事務所内観"
              className="rounded-xl shadow-lg object-cover w-full h-96 lg:h-full object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-gray-900/20 to-transparent rounded-xl"></div>
          </div>
        </div>

        {/* 事務所概要セクション */}
        <div className="mt-16 bg-gray-50 rounded-xl p-8">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">事務所概要</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="space-y-6">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-building-line text-xl text-blue-600"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">事務所名</h4>
                  <p className="text-gray-600">芦江土地家屋調査士事務所</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-user-line text-xl text-blue-600"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">代表者</h4>
                  <p className="text-gray-600">芦江諒介</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-map-pin-line text-xl text-blue-600"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">所在地</h4>
                  <p className="text-gray-600">大分県宇佐市大字江須賀1545番地の4</p>
                </div>
              </div>
            </div>

            <div className="space-y-6">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-phone-line text-xl text-blue-600"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">電話番号</h4>
                  <p className="text-gray-600">050-1726-1703 / 090-6420-2813</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-printer-line text-xl text-blue-600"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">FAX番号</h4>
                  <p className="text-gray-600">050-1809-0843</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-service-line text-xl text-blue-600"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">対応エリア</h4>
                  <p className="text-gray-600">大分県全域・近隣地域</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
